import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrailer = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M.75 8.25A.75.75 0 0 1 1.5 9v12.75c0 .414.336.75.75.75h19.5a.75.75 0 0 0 .75-.75V9A.75.75 0 0 1 24 9v12.75A2.25 2.25 0 0 1 21.75 24H2.25A2.25 2.25 0 0 1 0 21.75V9a.75.75 0 0 1 .75-.75ZM2.25 1.5a.75.75 0 0 0-.75.75v3h21v-3a.75.75 0 0 0-.75-.75H2.25ZM0 2.25A2.25 2.25 0 0 1 2.25 0h19.5A2.25 2.25 0 0 1 24 2.25V6a.75.75 0 0 1-.75.75H.75A.75.75 0 0 1 0 6V2.25Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.206.03a.75.75 0 0 1 .515.926l-1.5 5.25a.75.75 0 1 1-1.442-.412l1.5-5.25A.75.75 0 0 1 9.206.03ZM16.706.03a.75.75 0 0 1 .515.926l-1.5 5.25a.75.75 0 1 1-1.442-.412l1.5-5.25a.75.75 0 0 1 .927-.515ZM9.153 12.011a.106.106 0 0 0-.153.095m-.739-1.365a1.606 1.606 0 0 1 1.562-.072l5.789 2.895a1.605 1.605 0 0 1 0 2.872l-5.789 2.895A1.608 1.608 0 0 1 7.5 17.894v-5.788c0-.556.288-1.073.761-1.365Zm.892 1.27 5.788 2.895-5.788-2.895ZM9 12.106v5.788a.106.106 0 0 0 .153.095l5.788-2.895a.106.106 0 0 0 .06-.094.106.106 0 0 0-.06-.094"
	})]
});
export { SvgTrailer as ReactComponent };
